// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"breadcrumbs--FTOIN","open":"open--IvMSN","crumb":"crumb--BZj_B"};